import * as LabelPrimitive from '@radix-ui/react-label';
import * as React from 'react';

import { cn } from '../../lib/utils.js';

/**
 * shadcn Label — minimal Radix wrapper.
 *
 * Required by FormLabel. Renders as a <label> element by default;
 * consumers associate it with a control via the standard htmlFor /
 * nested-input pattern. The data-slot attribute lets the Form
 * style it via the error state without prop drilling.
 */
const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    data-slot="label"
    className={cn(
      'text-sm font-medium leading-none select-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
      className,
    )}
    {...props}
  />
));
Label.displayName = 'Label';

export { Label };
